import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from '@gn-audio/jss-components';

import { TopBannerItem, TopBannerItemProps } from 'composables/Product/TopBanner/TopBannerItem';

export type TopBannerProps = ComponentProps & TopBannerItemProps;

const TopBanner = ({ fields }: TopBannerProps) => {
  return <TopBannerItem fields={fields}></TopBannerItem>;
};

export default withDatasourceCheck()(TopBanner);
